import React, { createContext, useContext, useState, ReactNode } from 'react';

/**
 * Holds the currently selected AI Authority report (by lars_report_id) so the
 * selection persists when navigating between the AEO dashboard and the platform
 * deep-dive page. null → default to the latest report.
 */
interface AeoReportContextValue {
  selectedReportId: string | null;
  setSelectedReportId: (id: string | null) => void;
}

const AeoReportContext = createContext<AeoReportContextValue>({
  selectedReportId: null,
  setSelectedReportId: () => {},
});

export const AeoReportProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedReportId, setSelectedReportId] = useState<string | null>(null);
  return (
    <AeoReportContext.Provider value={{ selectedReportId, setSelectedReportId }}>
      {children}
    </AeoReportContext.Provider>
  );
};

export function useAeoReport(): AeoReportContextValue {
  return useContext(AeoReportContext);
}
